import ErrorBoundary from 'components/error-boundaries';
import { ClosedPositionsStats } from 'api/types/httpsTypes/marketplace-performance';
import Table, { Body } from 'modules/shared-components/data-display/table';
import {
  closedPositionsColumn,
  Position,
} from 'modules/marketplace-performance-page/components/closed-positions-chart-column';
import Tooltip from 'modules/shared-components/tooltip';

interface Props {
  closedPositionsStats: ClosedPositionsStats;
}

const ClosedPositions = ({ closedPositionsStats }: Props) => {
  return (
    <ErrorBoundary>
      <div className="space-y-6">
        <div className="text-sm font-medium text-black-900 dark:text-white-50 ">
          Last 100 Positions{' '}
          <Tooltip text="The last 100 closed positions. The data is not real-time, a random updating delay is applied.">
            <span className="inline-block">
              <i className="mdi mdi-information-outline" />
            </span>
          </Tooltip>
        </div>
        <div className="overflow-scroll	max-h-[1000px]	">
          <Table>
            <Table.Header columns={closedPositionsColumn} />
            <Body
              columns={closedPositionsColumn}
              data={
                [...(closedPositionsStats?.positions || [])]
                  .reverse()
                  .map((position, index) => ({
                    ...position,
                    id: `${index}`,
                  })) as Position[]
              }
            />
          </Table>
        </div>
      </div>
    </ErrorBoundary>
  );
};
export default ClosedPositions;
